import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SokratesSsoScriptService } from '../../../shared/services/sokrates-sso-script.service';
import { AuthService, SsoLoginFailedError } from '../../../shared/services/auth.service';
import { SettingService } from '../../../shared/services/setting.service';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-sso-callback',
  template: `
    <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
      <div class="text-center">
        <i class="fa fa-spin fa-spinner fa-3x text-primary"></i>
        <p class="mt-3 text-muted" *ngIf="!errorMsg">Menyelesaikan proses login...</p>
        <div *ngIf="errorMsg" class="mt-3">
          <p class="text-danger">{{ errorMsg }}</p>
          <a class="btn btn-sm btn-outline-primary mt-2" href="/login">Kembali ke Login</a>
        </div>
      </div>
    </div>
  `,
})
export class SsoCallbackComponent implements OnInit {
  errorMsg: string | null = null;

  constructor(
    private ssoScript: SokratesSsoScriptService,
    private authService: AuthService,
    private settingService: SettingService,
    private userService: UserService,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    const carryAttempted = this.ssoScript.takeCarryAttempt();
    try {
      // handleRedirectCallback validasi state dari sessionStorage dan ekstrak code
      const result = await this.ssoScript.handleRedirectCallback(window.location.href);

      if (result.autoLogin) {
        if (this.authService.current()) {
          this.router.navigate(['/layout/dashboard']);
          return;
        }
        return this.authService.logout();
      }

      // Opened from a switched app: signed in as the actor, now take over that app's switch.
      const carryFrom = result.switched ? null : this.ssoScript.takeCarryFrom();
      if (carryFrom) {
        await this.authService.completeSsoLoginAndCarrySwitch(result, carryFrom);
        return;
      }

      const switched = Boolean(result.switched);
      await this.authService.completeSsoLogin(result, switched);
      if (!switched) {
        this.loadTimezone();
      }
    } catch (err: any) {
      // Nothing to carry (the other app was no longer switched): already signed in as the actor.
      if (carryAttempted && this.authService.current()) {
        console.warn('[SsoCallback] switch not carried', err?.code ?? err);
        this.router.navigate(['/layout/dashboard']);
        return;
      }

      console.error('[SsoCallback] SSO login error:', err);
      // A callback that answered without an account (e.g. user_inactive), or a failed exchange.
      const message = err instanceof SsoLoginFailedError ? err.response?.message : err?.error?.message || err?.message;
      this.errorMsg = message || 'SSO login gagal. Coba lagi.';
    }
  }

  /** The tenant's timezone, read with the stored token (the request outlives this page). */
  private loadTimezone(): void {
    this.userService.getTimezone(this.settingService.getToken()).subscribe(
      (tzRes: any) => this.settingService.setConfig('timezone', tzRes?.result?.data?.timezone || 'Etc/GMT-7'),
      () => this.settingService.setConfig('timezone', 'Etc/GMT-7'),
    );
  }
}
